import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITowersLess12 } from './towers-less-12';
import { ITowersTraconsImportstepsMsg } from './towers-tracons-import-steps-msg';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TowersTraconsImportStepsService {

    private _towersImporStepsLess12tUrl = `api/systemmanagement`;
 
    constructor(private httpHelper: HttpHelper) { }

    public getTowersImportStepsLess12(): Observable<ITowersLess12> {
         return this.httpHelper.get(`${this._towersImporStepsLess12tUrl}/TowersImportStepsLess12`)
    }
    public startOpsnetTowersImport():Observable<ITowersTraconsImportstepsMsg>{
         return this.httpHelper.get(`${this._towersImporStepsLess12tUrl}/TowersOpsnetImport`)
    }
    public reforecastAOPS():Observable<ITowersTraconsImportstepsMsg>{
         return this.httpHelper.get(`${this._towersImporStepsLess12tUrl}/TowersReforecastAops`)
    }

    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/towers-tracons-import/towers-tracons-import-steps/towers-tracons-import-steps.service.ts
 **/